import { monotonicFactory } from "ulid"

export const ulid = monotonicFactory()
